import { render } from "./RelationManage.vue?vue&type=template&id=143148cc"
import script from "./RelationManage.vue?vue&type=script&lang=js"
export * from "./RelationManage.vue?vue&type=script&lang=js"
script.render = render

export default script